/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_viewer$ref = any;
export type PdpSharedBlurbShipping_viewer$ref = any;
export type PdpSharedBlurbShipping_viewer = {
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_viewer$ref;
    readonly " $refType": PdpSharedBlurbShipping_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbShipping_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '4cf15ba4689b43624455f8bddad665f4';
export default node;
